import { Component, OnInit } from '@angular/core';
import { InputComponent } from '../../utilities/input/input.component';
import { OtpFieldComponent } from '../../components/otp-field/otp-field.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ButtonComponent } from "../../utilities/button/button.component";
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [InputComponent, OtpFieldComponent, CommonModule, ButtonComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  texts: string[] = [
    'Engage Customers. Boost Loyalty. Drive Growth.',
    'Create Rewards That Keep Your Customers Coming Back',
    'Drive Customer Retention with Tailored Rewards',
    'Boost Engagement with Easy-to-Create Rewards',
  ];
  currentText: string = '';
  isDeleting: boolean = false;
  loopIndex: number = 0;
  charIndex: number = 0;
  typingSpeed: number = 150;
  backspaceSpeed: number = 75;
  pauseTime: number = 1000;
loading: boolean = false;
  OTPState: boolean = false;
  otp: string = '';
  otpId: string = '';
  loginData: any = {
    emailAddress: '',
  };
  errors = {
    emailAddress: '',
  };

  constructor(private router: Router, private authService: AuthService, private notification: NzNotificationService, private generalService: GeneralService) {}

  ngOnInit(): void {
    this.startTypingEffect();
  }
  routeTo = (route: string) => {
    this.router.navigate([`/${route}`]);
  };

  startTypingEffect(): void {
    const currentIndex = this.loopIndex % this.texts.length;
    const fullText = this.texts[currentIndex];

    if (this.isDeleting) {
      this.currentText = fullText.substring(0, this.charIndex--);
    } else {
      this.currentText = fullText.substring(0, this.charIndex++);
    }

    if (!this.isDeleting && this.charIndex === fullText.length) {
      setTimeout(() => (this.isDeleting = true), this.pauseTime);
    } else if (this.isDeleting && this.charIndex === 0) {
      this.isDeleting = false;
      this.loopIndex++;
      setTimeout(() => this.startTypingEffect(), this.pauseTime);
      return;
    }

    const speed = this.isDeleting ? this.backspaceSpeed : this.typingSpeed;
    setTimeout(() => this.startTypingEffect(), speed);
  }
  setEmail = (value: string) => {
    this.loginData.emailAddress = value;
    if (value === '') {
      this.errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(value)) {
      this.errors.emailAddress = 'Please use a valid email*';
    } else {
      this.errors.emailAddress = '';
    }
  };

  setOTP = (otp: string) => {
    this.otp = otp;
    if(this.otp.length == 6){this.signIn()}
  };
  validateForm = () => {
    const errors: any = {};
    if (this.loginData.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(this.loginData.emailAddress)) {
      errors.emailAddress = 'Please use a valid email*';
    }
    // console.log(errors);
    return errors;
  };
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  sendOTP = () => {
    this.loading = true;
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
      this.authService.signin(this.loginData).subscribe(
        (res: any) => {
          if (res.statusCode === 200) {
            // console.log(res);
            this.loading = false
            this.OTPState = !this.OTPState;
            this.otpId = res.data.otpId;
            this.notification.success(
              'Success',
              'OTP Sent Successfully',
              { nzClass: 'notification' }
            );
          } else {
          }
        },
        (error) => {
          // console.log(error);
          this.loading = false;
          if(error.error.statusCode == 400){
            this.notification.error(
              'Error',
              error.error.message,
              { nzClass: 'notification' }
            );
          }
          else{
          this.notification.error(
            'Error',
            'Something went wrong',
            { nzClass: 'notification' }
          );}
        }
      );
    }
  };
  signIn = () => {
    this.loading = true;
    this.loginData.otpId = this.otpId;
    this.loginData.otp = this.otp;
    this.authService.signin(this.loginData).subscribe(
      (res: any) => {
        // console.log(res.data.jwtToken);
        this.generalService.setToken(res.data.jwtToken);
         this.otpId =  res.data.otpId;
         this.routeTo('dashboard');
         this.notification.success(
          'Success',
          'Sign In Successful',
          { nzClass: 'notification' }
        );
         this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.notification.error(
          'Error',
          'Something went wrong',
          { nzClass: 'notification' }
        );
      }
    );
  }
}
